var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0364 2C5.92958 2 1 6.81593 1 12.7819C1 17.526 4.16376 21.5512 8.57831 22.9888C9.16692 23.0607 9.31407 22.7732 9.31407 22.4857V20.6168C6.22389 21.2637 5.5617 19.1792 5.5617 19.1792C5.04667 17.9573 4.31091 17.5979 4.31091 17.5979C3.28085 16.9509 4.38449 16.9509 4.38449 16.9509C5.48813 17.0228 6.07673 18.0291 6.07673 18.0291C7.03322 19.6824 8.65189 19.1792 9.31407 18.8917C9.38765 18.1729 9.68195 17.7416 10.0498 17.4541C7.62183 17.1666 5.04667 16.2322 5.04667 12.135C5.04667 10.9849 5.48813 9.97863 6.15031 9.25983C6.00316 8.97232 5.63528 7.89412 6.22389 6.38465C6.22389 6.38465 7.18037 6.09713 9.2405 7.46285C10.1234 7.24721 11.0799 7.10345 12.0364 7.10345C12.9929 7.10345 13.9494 7.24721 14.8323 7.46285C16.966 6.09713 17.8489 6.38465 17.8489 6.38465C18.4375 7.89412 18.0696 8.97232 17.9225 9.25983C18.6582 9.97863 19.0261 10.9849 19.0261 12.135C19.0261 16.304 16.4509 17.1666 14.0229 17.4541C14.3908 17.8135 14.7587 18.4604 14.7587 19.4667V22.4138C14.7587 22.7013 14.9794 23.0607 15.4944 22.9169C19.909 21.4794 22.9992 17.4541 22.9992 12.7101C23.0728 6.81593 18.1432 2 12.0364 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub2);
export default __webpack_public_path__ + "static/media/github2.44f3d8065c81bcd9f1f2e2bd5e27851e.svg";
export { ForwardRef as ReactComponent };